import React from 'react'
import '../styles/footer.css'

export default props => (
    <footer className="footer">
      <div className="container">
        <a target="_blank" rel="noopener noreferrer" id="homepage" href="https://www.gasag.de/privatkunden"><span className="text-muted">Homepage</span></a>
        <a target="_blank" rel="noopener noreferrer" id="kontakt" href="https://www.gasag.de/privatkunden/service/kundenservice/kontakt"><span className="text-muted">Kontakt</span></a>
        <a target="_blank" rel="noopener noreferrer" id="impressum" href="https://www.gasag.de/footer/impressum"><span className="text-muted">Impressum</span></a>
        <a target="_blank" rel="noopener noreferrer" id="datenschutzhinweise" href="https://www.gasag.de/footer/datenschutzhinweise"><span className="text-muted">Datenschutzhinweise</span></a>
      <span className="text-muted">{props.text}</span>
      <span>&nbsp;v{props.version}</span>
      </div>
    </footer>
)


// WEBPACK FOOTER //
// ./src/components/Footer.js